/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
import { usePromiseTracker } from 'react-promise-tracker'
import LoadingOverlay from 'react-loading-overlay-ts'
import { Oval } from 'react-loader-spinner'

export const LoadingSpinerComponent = () => {
  const { promiseInProgress } = usePromiseTracker({ delay: 0 })
  return (
    <>
      {promiseInProgress ? (
        <LoadingOverlay
          className="position-absolute w-100 h-100 h-full"
          styles={{
            overlay: (base: any) => ({
              ...base,
              height: document.body.scrollHeight,
              background: 'rgb(255,255,255)'
            })
          }}
          active={true}
          spinner={<LoaderItem />}
        />
      ) : null}
    </>
  )
}

const LoaderItem = () => {
  return <Oval color="#0033A2" secondaryColor="#0033A2" height={100} width={100} />
}
